module.exports = __webpack_public_path__ + "img/cave37.42966284.jpg";